import { render, staticRenderFns } from "./LeagueIgnoreConfig.vue?vue&type=template&id=d02b918e&scoped=true&"
import script from "./LeagueIgnoreConfig.vue?vue&type=script&lang=js&"
export * from "./LeagueIgnoreConfig.vue?vue&type=script&lang=js&"
import style0 from "./LeagueIgnoreConfig.vue?vue&type=style&index=0&id=d02b918e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02b918e",
  null
  
)

export default component.exports